import { defineMeta } from '@/registry/types';

export const datePickerMeta = defineMeta({
  name: 'DatePicker',
  level: 'molecule',
  category: 'input',
  classification: 'themed-mui',
  description: 'Calendar-based date selection. Themed MUI X DatePicker (dayjs).',
  baseLibrary: '@mui/x-date-pickers',
  muiEquivalent: 'DatePicker',
  muiDocs: 'https://mui.com/x/react-date-pickers/date-picker/',
  a2uiEquivalent: 'DatePicker',
  importPath: '@/molecules/DatePicker',
  optionalProps: ['value', 'defaultValue', 'minDate', 'maxDate', 'disabled', 'onChange'],
  supportedStates: ['default', 'open', 'disabled', 'error'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Keyboard operable; ensure a visible label is set.'],
  usageExamples: ['<DatePicker label="Detected on" value={d} onChange={set} />'],
  antiPatterns: ['Do not use for free-text date entry without validation.'],
  llmSafe: true,
  whenToUse: ['Selecting a single calendar date'],
  whenNotToUse: ['Date ranges (use a range picker)', 'Times only (use TimePicker)'],
});

export default datePickerMeta;
